import styles from "./chart.module.css"

import React from "react"
import * as recharts from "recharts"
import * as util from "activities/util"
import * as chartUtil from "activities/components/charts/util"
import * as fonts from "shared/fonts"

const barColors = (theme) => ({
  disabled: {
    0: "dbdee0",
    1: "dbdee0"
  },
  inactive: {
    0: theme["color-1"],
    1: theme["color-4"],
    2: theme["color-2"]
  }
})

// DATA STRUCTURE for Bar Chart
// legend: {
//   x: {
//     label: "Years",
//     key: "year"
//   },
//   y: {
//     label: "Annual Payments",
//     type: "currency"
//   }
// },
// fields: {
//   "year": {type: "number", tooltip: {title: "Year", order: 0}},
//   "loanAmt": {type: "currency", barOrder: 1, tooltip: {title: "Principal", order: 2, color: "color-1"}},
//   "interest": {type: "currency", barOrder: 2, tooltip: {title: "Interest", order: 1, color: "color-4"}}
// },
// values: {
//   x: util.xAxisArray(amortization.length),
//   y: amortization
// }

const stackedBar = ({activeIndex, theme, data, disabled, handleMouseOver, handleMouseOut}) => {
  const ks = Object.keys(data.fields)
    .filter((k) => {
      return typeof data.fields[k].barOrder === "number"
    })
    .sort((a, b) => data.fields[a].barOrder - data.fields[b].barOrder)
  const changeBarColor = data.legend.y.changeBarColorOnNegativeNum
  const value = data.legend.y.barToChangeOnNegative
  const clrs = barColors(theme)
  return ks.map((k, idx) => (
    <recharts.Bar key={k} stackId="a" dataKey={k} isAnimationActive={false} onMouseEnter={handleMouseOver} onMouseOut={handleMouseOut} barSize={12}>
      {data.values.y.map((entry, index) => (
        <recharts.Cell
          key={index}
          fill={`#${clrs[disabled ? "disabled" : "inactive"][!changeBarColor ? idx : value && entry[value] < 0 ? idx + 1 : idx]}`}
          fillOpacity={index === activeIndex ? 0.6 : 1}
        />
      ))}
    </recharts.Bar>
  ))
}

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeBarIdx: null
    }
  }
  handleMouseOver(entry, index) {
    this.setState({activeBarIdx: index})
  }
  handleMouseOut() {
    this.setState({activeBarIdx: null})
  }
  render() {
    const activeIndex = this.state.activeBarIdx
    const {data, disabled, theme, ...props} = this.props
    if (!data) {
      return null
    }
    const rowCount = props.rowcount || Object.keys(data.fields).length

    return (
      <div className={styles["chart"]} {...props} role="img">
        <chartUtil.AxisLabel label={data.legend.y.label} axis="yaxis" />
        <recharts.ResponsiveContainer width={"100%"} height={"100%"}>
          <recharts.BarChart data={data.values.y} margin={{left: 28}}>
            <recharts.XAxis
              dataKey={data.legend.x.key}
              interval={0}
              axisLine={false}
              tickLine={false}
              ticks={util.getScreenWidth() < 620 || data.values.x.length > 12 ? chartUtil.getXAxisTicks(data.legend.x.key, data.values.y) : []}
              tick={{
                fontSize: "12",
                fontFamily: fonts.getFontFamily(),
                letterSpacing: ".13em",
                fill: "#5C5761",
                dy: 8
              }}
            />
            <recharts.YAxis
              allowDecimals={false}
              type="number"
              domain={[0, (dataMax) => chartUtil.getYAxisRange(dataMax)]}
              axisLine={false}
              tickLine={false}
              tickFormatter={(tick) => util.formatDollarsNoCents(tick)}
              tick={{
                fontSize: "12",
                fontFamily: fonts.getFontFamily(),
                fill: "#5C5761"
              }}
            />
            {!disabled && <recharts.Tooltip cursor={false} content={<chartUtil.CustomTooltip data={data} theme={theme} />} wrapperStyle={chartUtil.tooltipStyles(rowCount)} />}
            {stackedBar({
              activeIndex: activeIndex,
              theme: theme,
              data: data,
              disabled: disabled,
              handleMouseOver: this.handleMouseOver.bind(this),
              handleMouseOut: this.handleMouseOut.bind(this)
            })}
          </recharts.BarChart>
        </recharts.ResponsiveContainer>
        <chartUtil.AxisLabel label={data.legend.x.label} axis="xaxis" />
      </div>
    )
  }
}
